<document-image *ngIf="reLoadDocuments"
	[searchDocumentDataCollection]="searchDocumentDataCollection"
	[documentItemKeyCollection]="documentItemKeyCollection"
	[minimalComponent]="minimalComponent"
	[hideCloseButton]="hideCloseButton"
	[hideFilterOptions]="hideFilterOptions"
	[hideColumnsForComplianceManagement]="hideColumnsForComplianceManagement"
	[hideAddRequirement]="hideAddRequirement"
	[hideAddDocuments]="hideAddDocuments"
	[isViewOnly]="isViewOnly">
</document-image>
